import { put, call, takeEvery } from 'redux-saga/effects';
import { axiosInstance, apiURL } from 'config';

import {
  loadInquiriesFail,
  loadInquiriesRequested,
  loadInquiriesSuccess,
} from './inquirySlice';

export function* loadInquiriesEffect(action: {
  type: string;
  payload: any;
}): Generator<any, void, any> {
  try {
    const { data } = yield call(
      axiosInstance.get,
      `${apiURL}/contact-index?searchString=${
        action?.payload?.filters?.query ?? ''
      }&page=${action.payload.page}&pageSize=${action.payload.perPage}`
    );

    yield put(loadInquiriesSuccess(data));
  } catch (error: any) {
    yield put(loadInquiriesFail(error.message));
  }
}

export function* inquriesSaga(): Generator<any, void, any> {
  yield takeEvery(loadInquiriesRequested, loadInquiriesEffect);
}
